import * as React from 'react';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import { ErrorTextDateMessage,EndDateValidationMessage,StartDateValidationMessage } from '../TextInputUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { GetCityList } from '../../services/apiServices/PostServices';
import { showToast } from '../constants/Toaster';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Popper } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


export const ReportsFilter = (props) => {
    const [open, setOpen] = React.useState(false);
    const [investmentType, setInvestmentType] = useState("");
    const [cityName, setCityName] = React.useState([]);
    const [investmentName, setInvestmentName] = useState([]);
    const [cityId, setCityId] = React.useState("");
    const [stateName, setStateName] = React.useState([]);
    const [stateId, setStateId] = React.useState("");
    const [investmentId, setInvestmentId] = React.useState("");
    const [filtersApplied, setFiltersApplied] = React.useState(false)
    const [cityListData, setCityListData] = React.useState([])
   
    const statesData = props?.stateData
    const investmentTypeData = props?.investmentType
    const today = new Date();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
  
    useEffect(() => {
        if (props?.appliedFilers !== undefined) {
            // setFiltersApplied(false)
            setStateId(props?.appliedFilers?.state_id)
            setCityId([props?.appliedFilers?.city_id])
            setInvestmentId(props?.appliedFilers?.share_type)
            setStartDate(props?.appliedFilers?.from)
            setEndDate(props?.appliedFilers?.to)
        }
    }, [props?.appliedFilers]);


    useEffect(() => {
        if (props?.searchFilter) {
            setFiltersApplied(false)
        }
    }, [props?.searchFilter]);
    
    useEffect(() => {
        if (stateId.length !== 0 && stateId.length === 1) {
            callCitylistApi()
        } else {
            setCityListData([])
        }
    }, [stateId]);

    //function to call city api
    const callCitylistApi = async () => {
        const reqbody = {
            state_id: stateId[0]
        }
        const res = await GetCityList(`city`, reqbody)
        if (res?.success) {
            setCityListData(res?.data)
        } else {
            console.log("res", res?.message)
        }
    }

    //function call to hanlde start date 
    const handleStartDateChange = (date) => {
        if (date instanceof Date && !isNaN(date)) {
            setStartDate(date);
        } else {
            // Handle invalid date case
            console.error('Invalid date received');
            setStartDate(null);
        }
    };

    //function call to handle end date
    const handleEndDateChange = (date) => {
        if (date instanceof Date && !isNaN(date)) {
            setEndDate(date);
        } else {
            // Handle invalid date case
            console.error('Invalid date received');
            setEndDate(null);
        }
    };

    const handleCityId = (id) => {
        let newSelectedIds = [...cityId]
        if (!cityId.includes(id)) {
            // Add the ID to the array if checked
            newSelectedIds = [...newSelectedIds, id];
            setCityId(newSelectedIds)
        } else {
            // Remove the ID from the array if unchecked
            newSelectedIds = newSelectedIds.filter((selectedId) => selectedId !== id);
            setCityId(newSelectedIds)
        }
    }

    //function call to set state id 
    const handleStateId = (id) => {
        let newSelectedIds = [id]
        setStateId(newSelectedIds)
    }

    //function call to set investment id
    const handleInvestmentId = (id) => {
        setInvestmentId(id)
    }

    //function call to format date 
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        // Extract the year, month, and day
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');

        // Format the date as YYYY-MM-DD
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate
            ;
    }

    //function call to open filter
    const handleClickOpen = () => {
        setOpen(true);
    };

    //function call to clear filter
    const handleClear = () => {
        props?.clear()
        setStateName([])
        setStateId([])
        setCityName([])
        setCityId([])
        setStartDate()
        setEndDate()
        setInvestmentId("")
        setFiltersApplied(false)
    }

    //function call to close filer
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            if(!filtersApplied){
                setStateName([])
                setStateId("")
                setCityName([])
                setCityId("")
                setStartDate()
                setEndDate()
                setInvestmentId("")
                setInvestmentName([])
            }
            setOpen(false);
        }
    };

    //function call to onchange city
    const handleChangeCity = (event) => {
        const {
            target: { value },
        } = event;
        setCityName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    //function call for the on change investment
    const handleChangeInvestment = (event) => {
        const {
            target: { value },
        } = event;
        setInvestmentName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    //function call for the on change state
    const handleChangeState = (event) => {
        const {
            target: { value },
        } = event;
        setStateName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        //setCityId("")
        setCityName([])
    };

    const reqbody = {
        city_id: cityId[0],
        state_id: stateId[0],
        share_type: investmentId,
        from: startDate ? formatDate(startDate) : "",
        to: endDate ? formatDate(endDate) : "",
    }

    //function call get applied filters conditions 
    const handleFilterApply = () => {
        if (endDate < startDate) {
            showToast(3, ErrorTextDateMessage)
        }else if(startDate !== undefined&& endDate ===undefined){
           showToast(3,"Please enter end date")
        }
        else if(stateId.length === 0 && cityId.length === 0 && investmentId === '' && ((startDate === "" && endDate === "") || (startDate === null && endDate === null) || (startDate === undefined && endDate === undefined))){
            showToast(3,"Please select any filter option")
        }
        else if (stateId.length !== 0 || cityId.length !== 0 || investmentId !== '' || (startDate !== "" && endDate !== "")) {
            props?.reqBody(reqbody)
            setFiltersApplied(true)
            setStartDate()
            setEndDate()
            setInvestmentType([])
            setInvestmentName([])
            // setCityListData([])
            setOpen(false)
        }
    }

    const listItemTextStyle = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '200px', // Adjust as needed
    };

   
    return (
        <div>
            <div class="d-flex pointer">
                <div class="d-flex" onClick={handleClickOpen}>
                    <h6 class="secondColor d-flex justify-content-center align-items-center fw-bold mx-2 m-0">
                        Filter
                    </h6>
                    <i class="bi bi-funnel colorPrimary"></i>
                    {
                        filtersApplied  ?
                            <span style={{ width: "5px", height: "5px", backgroundColor: "red", borderRadius: "25px" }}></span> : null
                    }
                </div>
                {filtersApplied ?
                    <div class="border rounded mx-2 ">
                        <h6 class="colorOrange fw-bold mx-2 m-0" onClick={handleClear}>Clear</h6>
                    </div>
                    : null
                }
            </div>
            <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
                <DialogTitle sx={{ marginLeft: "20px", }}  >Filter</DialogTitle>
                <DialogContent  >
                    <Box component="form" sx={{
                        display: 'flex', flexWrap: 'wrap', marginLeft: "10px", height: 'auto', // Set height to auto if content height is dynamic
                        minHeight: '270px',
                    }}>

                        <FormControl sx={{ m: 1, width: 250 }}>
                            <InputLabel id="status">State</InputLabel>
                            <Select
                                labelId="State"
                                id="State"
                                value={stateName}
                                onChange={handleChangeState}
                                input={<OutlinedInput label="State" />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                {statesData.map((name) => (
                                    <MenuItem key={name.id} value={name.name} onClick={() => handleStateId(name.id)} >
                                        {/* <Checkbox checked={stateName.indexOf(name.name) > -1} /> */}
                                        <ListItemText primary={name.name} primaryTypographyProps={{ style: listItemTextStyle }} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 250 }}>
                            <InputLabel id="status">City</InputLabel>
                            <Select
                                labelId="City"
                                id="City"
                                value={cityName}
                                onChange={handleChangeCity}
                                input={<OutlinedInput label="City" />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                {cityListData.map((name) => (
                                    <MenuItem key={name.id} value={name.name} onClick={() => handleCityId(name.id)}>
                                        {/* <Checkbox checked={cityName.indexOf(name.name) > -1} /> */}
                                        <ListItemText primary={name.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl sx={{marginLeft:"8px"}}>
                            <DatePicker
                                // selected={startDate}
                                selected={startDate ? new Date(startDate) : null}
                                onChange={handleStartDateChange}
                                selectsStart
                                startDate={startDate}
                                dateFormat="dd/MM/yyyy"
                                maxDate={today}
                                endDate={endDate}
                                isClearable
                                placeholderText="Select Start Date"
                                customInput={<input className='customInputStyle' />}
                            />
                        </FormControl>
                        <FormControl sx={{marginLeft:"18px"}}>
                            <DatePicker
                                // selected={endDate}
                                selected={endDate ? new Date(endDate) : null}
                                onChange={handleEndDateChange}
                                selectsEnd
                                startDate={startDate}
                                dateFormat="dd/MM/yyyy"
                                maxDate={today}
                                endDate={endDate}
                                isClearable
                                placeholderText="Select End Date"
                                customInput={<input className='customInputStyle' />}
                            // Apply custom styles for calendar background
                            />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 250, marginTop: "13px" }}>
                            <InputLabel id="status">Investment Type</InputLabel>
                            <Select
                                labelId="Investment type"
                                id="Investment type"
                                value={investmentName}
                                onChange={handleChangeInvestment}
                                input={<OutlinedInput label="Investment type" />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                            >
                                {investmentTypeData.map((name) => (
                                    <MenuItem key={name.id} value={name.name} onClick={() => handleInvestmentId(name.id)}>
                                        {/* <Checkbox checked={cityName.indexOf(name.name) > -1} /> */}
                                        <ListItemText primary={name.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleFilterApply}>Apply</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
